<script setup lang="ts">
import { onMounted, nextTick, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const PayUnpaidRides = defineAsyncComponent(() => import('./Payments/PayUnpaidRides.vue') as any);

const PayUnpaidGroceries = defineAsyncComponent(() => import('./Payments/PayUnpaidGroceries.vue') as any);

const PayUnpaidServices = defineAsyncComponent(() => import('./Payments/PayUnpaidServices.vue') as any);

const ChargeRideImmediately = defineAsyncComponent(() => import('./Payments/ChargeRideImmediately.vue') as any);

const ManuallyAddCreditCard = defineAsyncComponent(() => import('./Payments/ManuallyAddCreditCard.vue') as any);

const CreditCardList = defineAsyncComponent(() => import('./Payments/CreditCardList.vue') as any);

const IndividualCharge = defineAsyncComponent(() => import('./Payments/IndividualCharge.vue') as any);

const Transactions = defineAsyncComponent(() => import('./Payments/Transactions.vue') as any);

const StripeCharge = defineAsyncComponent(() => import('./Payments/StripeCharge.vue') as any);

const TransactionDistributions = defineAsyncComponent(() => import('./Payments/TransactionDistributions.vue') as any);

const PayUnpaidGourmetOrders = defineAsyncComponent(() => import('./Payments/PayUnpaidGourmetOrders.vue') as any);

const CreditsBalance = defineAsyncComponent(() => import('./Payments/CreditsBalance.vue') as any);

const Disputes = defineAsyncComponent(() => import('./Payments/Disputes.vue') as any);

const PayOffDispute = defineAsyncComponent(() => import('./Payments/PayOffDispute.vue') as any);

const RefundPaidOffDispute = defineAsyncComponent(() => import('./Payments/RefundPaidOffDispute.vue') as any);

const ResolveDisputeWithoutCharge = defineAsyncComponent(() => import('./Payments/ResolveDisputeWithoutCharge.vue') as any);

const ExpiringCredits = defineAsyncComponent(() => import('./Payments/ExpiringCredits.vue') as any);

const ExpiringCreditTransactions = defineAsyncComponent(() => import('./Payments/ExpiringCreditTransactions.vue') as any);

const PaymentIntents = defineAsyncComponent(() => import('./Payments/PaymentIntents.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>

<template>
  <div class="page-content payments">
    <div class="row">
      <div class="col-md-6 col-sm-6 col-xs-12">
        <manually-add-credit-card />
        <refund-paid-off-dispute />
        <resolve-dispute-without-charge />
        <pay-off-dispute />
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <pay-unpaid-services />
        <pay-unpaid-groceries />
        <pay-unpaid-rides />
        <pay-unpaid-gourmet-orders />
        <charge-ride-immediately />
        <individual-charge />
      </div>
      <div class="col-sm-12">
        <credit-card-list />
        <transactions />
        <transaction-distributions />
        <stripe-charge />
        <payment-intents />
        <credits-balance />
        <disputes />
        <expiring-credits />
        <expiring-credit-transactions />
      </div>
    </div>
  </div>
</template>
